import { ChangeDetectorRef, Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TokenizerComponent } from 'src/app/tokenizer/tokenizer.component';
import { WatchAwareComponent } from 'src/app/watch-aware.component';
import { environment } from 'src/environments/environment';
import { Mouse } from 'src/graphics/mouse';
import { IRoomAsset } from 'src/sync/_api';
import { Account } from 'src/sync/account';
import { Room } from 'src/sync/room';
import { Store } from 'src/sync/store';
import { Kb } from 'src/util/kb';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-control-tokens',
    templateUrl: './control-tokens.component.html',
    styleUrls: ['./control-tokens.component.scss'],
    standalone: false
})
export class ControlTokensComponent extends WatchAwareComponent {
    public tokens: { id: string, src: string }[] = [];
    public tokenizer: MatDialogRef<TokenizerComponent> | undefined;
    public hoverId?: string;
    public deleteSubscription = Kb.on({ code: 'Delete' }, () => {
        if (this.hoverId) {
            const success = Room.deleteToken(this.hoverId);
            if (success) {
                Mouse.toggleErasing(false); // TODO: This is not a great fix
                this.hoverId = undefined;
            }
        }
    });

    constructor(
        public dialogs: MatDialog,
        public snackbar: MatSnackBar,
        public override changeDetectorRef: ChangeDetectorRef
    ) { super(changeDetectorRef) }

    public async ngAfterViewInit() {
        this.track(Room.tokenAssets.watchAll((keys) => this.loadTokens(keys)));
    }

    // TODO: very nearly copy+paste from app component, refactor w/ tokenzone attribute
    public uploadFile(event: any) {
        const file = event.currentTarget.files[0] as File;
        if (file == null) return;
        const url = URL.createObjectURL(file);
        const imageTransfer = new Image();

        imageTransfer.onload = async (e: Event) => {
            if (url == Store.imageUploadUrl) return;
            if (this.tokenizer) return;

            Store.imageUploadUrl = url;
            Store.imageUpload = e.target as HTMLImageElement;

            const myTokenCount = Room.tokenAssets.asArray().filter(x => x.uploaderId == Account.id).length;
            if (Store.isReferee.value == false && myTokenCount >= 10) {
                this.snackbar.open('Maximum token uploads is 10.', 'Dismiss', { duration: 2000 });
                return;
            }

            this.tokenizer = this.dialogs.open(TokenizerComponent);
            const closeEvent = this.tokenizer.afterClosed();
            closeEvent.subscribe(() => this.tokenizer = undefined);
            (event.target as HTMLInputElement).value = ''; // NB: Clear the input to allow potential same file uploads
        }
        imageTransfer.src = url;
    }

    private loadTokens(tokenIds: string[]) {
        this.tokens = [];
        for (let id of tokenIds) {
            const asset = Room.tokenAssets.get(id) as IRoomAsset;
            const token = { id, src: `${environment.assetsUrl}/${asset.name}` };
            this.tokens.push(token);
        }
        this.changeDetectorRef.detectChanges();
    }

    public override ngOnDestroy() {
        super.ngOnDestroy();
        this.deleteSubscription.unsubscribe();
    }
}
